export default __webpack_public_path__ + "static/coflex-9208d8103bc1564f5dcefd50efec4b23.jpg";